(() => {
  const gate = document.getElementById('rb-age-gate');
  const content = document.getElementById('rb-age-content');
  if (!gate || !content || gate.dataset.ready) return;
  gate.dataset.ready = 'true';
  const key = 'rb_age_gate_v1';
  const question = gate.querySelector('[data-rb-age-question]');
  const denied = gate.querySelector('[data-rb-age-denied]');
  const accept = gate.querySelector('[data-rb-age-accept]');
  const decline = gate.querySelector('[data-rb-age-decline]');
  const retry = gate.querySelector('[data-rb-age-retry]');
  const backgroundVideo = gate.querySelector('[data-rb-age-video]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let videoReleased = false;
  let videoFailed = false;
  function stopBackgroundVideo() {
    if (!backgroundVideo) return;
    backgroundVideo.pause();
    backgroundVideo.hidden = true;
    if (backgroundVideo.hasAttribute('src')) {
      backgroundVideo.removeAttribute('src');
      backgroundVideo.load();
    }
  }
  function startBackgroundVideo() {
    if (!backgroundVideo || videoReleased || videoFailed || reducedMotion.matches || gate.hidden || document.hidden) return;
    if (!backgroundVideo.hasAttribute('src')) {
      backgroundVideo.muted = true;
      backgroundVideo.defaultMuted = true;
      backgroundVideo.src = window.matchMedia('(max-width: 767px)').matches ? backgroundVideo.dataset.mobileSrc : backgroundVideo.dataset.desktopSrc;
    }
    backgroundVideo.hidden = false;
    backgroundVideo.play()?.catch(() => {
      if (videoReleased || reducedMotion.matches || document.hidden) return;
      videoFailed = true;
      stopBackgroundVideo();
    });
  }
  function updateMotion() {
    if (reducedMotion.matches) stopBackgroundVideo(); else startBackgroundVideo();
  }
  function updateVisibility() {
    if (document.hidden) backgroundVideo?.pause(); else startBackgroundVideo();
  }
  function releaseBackgroundVideo() {
    videoReleased = true;
    stopBackgroundVideo();
    reducedMotion.removeEventListener('change', updateMotion);
    document.removeEventListener('visibilitychange', updateVisibility);
  }
  backgroundVideo?.addEventListener('playing', () => {
    if (!videoReleased && !reducedMotion.matches) backgroundVideo.hidden = false;
  });
  backgroundVideo?.addEventListener('error', () => {
    if (!backgroundVideo.hasAttribute('src')) return;
    videoFailed = true;
    stopBackgroundVideo();
  });
  function save(value) { try { sessionStorage.setItem(key, value); } catch {} }
  function read() { try { return sessionStorage.getItem(key); } catch { return null; } }
  function setDenied(value) {
    question.hidden = value; denied.hidden = !value;
    gate.setAttribute('aria-labelledby', value ? 'rb-age-denied-title' : 'rb-age-title');
    gate.setAttribute('aria-describedby', value ? 'rb-age-denied-text' : 'rb-age-description');
    if (value) gate.querySelector('#rb-age-denied-title').focus(); else accept.focus();
  }
  let unlocking = false;
  function unlock(focus) {
    if (unlocking) return;
    unlocking = true;
    const animate = focus && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let fallback;
    let finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      clearTimeout(fallback);
      content.removeEventListener('transitionend', onEnd);
      content.classList.remove('rb-age-reveal', 'rb-age-revealing');
      gate.classList.remove('rb-age-leaving');
      content.hidden = false; content.inert = false;
    document.documentElement.style.overflow = '';
    if (typeof gate.close === 'function') gate.close();
    gate.hidden = true;
    releaseBackgroundVideo();
    document.dispatchEvent(new CustomEvent('rb:age-accepted'));
    if (focus) {
      const main = document.getElementById('MainContent');
      if (main) { main.setAttribute('tabindex', '-1'); main.focus({preventScroll:true}); }
    }
    content.querySelectorAll('video[autoplay]').forEach(video => { if (video.muted) video.play()?.catch(() => {}); });
    }
    function onEnd(event) {
      if (event.target === content && event.propertyName === 'opacity') finish();
    }
    if (!animate) { finish(); return; }
    [accept, decline, retry].forEach(button => { button.disabled = true; });
    content.classList.add('rb-age-reveal');
    content.hidden = false;
    content.addEventListener('transitionend', onEnd);
    fallback = setTimeout(finish, 850);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (finished) return;
        gate.classList.add('rb-age-leaving');
        content.classList.add('rb-age-revealing');
      });
    });
  }
  [accept, decline, retry].forEach(button => { button.disabled = false; });
  accept.addEventListener('click', () => { save('yes'); unlock(true); });
  decline.addEventListener('click', () => { save('no'); setDenied(true); });
  retry.addEventListener('click', () => { save('no'); setDenied(false); });
  gate.addEventListener('cancel', event => event.preventDefault());
  gate.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const nodes = [...gate.querySelectorAll('button:not(:disabled), a[href]')].filter(node => node.getClientRects().length);
    if (!nodes.length) return;
    const first=nodes[0], last=nodes[nodes.length-1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === gate.querySelector('#rb-age-denied-title'))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  if (read() === 'yes') { unlock(false); return; }
  content.querySelectorAll('video').forEach(video => video.pause());
  document.documentElement.style.overflow = 'hidden';
  if (typeof gate.showModal === 'function') { gate.removeAttribute('open'); gate.showModal(); }
  setDenied(read() === 'no');
  reducedMotion.addEventListener('change', updateMotion);
  document.addEventListener('visibilitychange', updateVisibility);
  startBackgroundVideo();
})();



